import { render, staticRenderFns } from "./moreText.vue?vue&type=template&id=ac4851e8&scoped=true&"
import script from "./moreText.vue?vue&type=script&lang=ts&"
export * from "./moreText.vue?vue&type=script&lang=ts&"
import style0 from "./moreText.vue?vue&type=style&index=0&id=ac4851e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac4851e8",
  null
  
)

export default component.exports